import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { BlockService } from '../block.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-block-register',
  templateUrl: './block-register.component.html',
  styleUrls: ['./block-register.component.scss']
})
export class BlockRegisterComponent implements OnInit {
  block_register_form: FormGroup;
  action: string = '';
  districts = [];
  constructor(private formBuilder: FormBuilder, private service : BlockService, private http: HttpService, private global: GlobalService) {
    this.getDistrict();
    this.block_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])],
      district_id: [null, Validators.compose([Validators.required])],
    })

    if (this.service.get_block_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.service.get_block_data);
    }

    this.service.BlockUpdate.subscribe((relation_data) => {
      if (relation_data === null) {
        this.action = 'register';
        this.block_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(relation_data);
      }
    });

    this.service.BlockUpdate.subscribe((relation_type) => {
      this.setupUpdateForm(relation_type);
    });
  }

  getDistrict() {
    this.http.getDistrict().subscribe((data: []) => {
      console.log(data);
      this.districts = data;
    }, (error) => {
      console.log(error);
    });
  }

   setupUpdateForm(district) {
    this.block_register_form.controls['id'].setValue(district['id']);
    this.block_register_form.controls['name'].setValue(district['name']);
    this.block_register_form.controls['district_id'].setValue(district['district_id']);
   }

   registerBlock() {
    const taluk_data = Object.assign({}, this.block_register_form.value);
    console.log(taluk_data)
    this.http.saveBlock(taluk_data).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.block_register_form.reset();
      this.service.downloadBlock.emit(true);
    });
  }

  getBlocks() {}

  ngOnInit() {
  }

}
